import React from 'react';
import { colorGrid } from 's2s-themes';
// import Select from 's2s-select';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { getIntlText } from '../js/utilities';
// import useSettings from "../hooks/settings";
import * as svgIcons from 's2s-svg-content';
import Button from 's2s-button';
import moment from 'moment';

const ImportContactsContainer = styled.div`
  background-color: ${colorGrid.gray0};
  overflow: auto;
  padding-top: 10px;
`;

const ImportListContainer = styled.li`
  list-style-type: none;
  padding: 0;
  margin-bottom: 20px;
  display: flex;
  height: 40px;
  align-items: center;
`;

const Logo = styled.div`
  min-height: 40px;
  min-width: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.background ? props.background : colorGrid.red5};
`;

const ImportSourceLabel = styled.p`
  color: #001221;
  display: flex;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
  margin-left: 8px;
`;

const ImportSourceLabelContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const LastSync = styled.div`
  padding-left: 48px;
  font-size: 12px;
  line-height: 16px;
  color: ${colorGrid.gray6};
  letter-spacing: 0.4px;
`;

const ImportButton = styled(Button)`
  background: #243991;
  color: ${colorGrid.gray0};
  font-family: Open Sans;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.75px;
  text-transform: uppercase;
  
  :hover {
    background: #182661;
  };
`;

const ImportContacts = (props) => {


  // const [settings, { changeSettings }] = useSettings();
  // console.log(settings);

  // const handleChangeRingtone = (selectedItem) => {
  //   changeSettings({ "selectedRingTone": selectedItem.value });
  // };

  const ImportSourcesArea = props.importSourceArray.map((sourceSettings) => {
    const ImportSourceSvg = svgIcons[sourceSettings.importSourceSvg];

    const formattedSyncDate = sourceSettings.importSourceLastSync ?
      (<LastSync className='lastSync' >
        {getIntlText(props.intl, 'SETTINGS-IMPORT-LAST-SYNC-LABEL', "Imported")} {moment(parseInt(sourceSettings.importSourceLastSync)).format('L')}
      </LastSync>) :
      undefined;

    return (
      <React.Fragment key={sourceSettings.importSourceName}>
        <ImportListContainer lastSync={sourceSettings.importSourceLastSync} className='importSourceListItem'>
          <Logo background={sourceSettings.importSourceLogoColor} className='importSourceLogo'>
            <ImportSourceSvg
              svgStyle={{
                fill: '#f8f9fa',
                height: '24px',
                width: '24px',
              }}
            />
          </Logo>
          <ImportSourceLabelContainer>
            <ImportSourceLabel className='importSourceLabel' >
              {sourceSettings.importSourceName}
            </ImportSourceLabel>
          </ImportSourceLabelContainer>
          <ImportButton
            ariaLabel={getIntlText(props.intl, 'SETTINGS-IMPORT-CONTACTS-SOURCES-BUTTON', "Import")}
            buttonLabel={getIntlText(props.intl, 'SETTINGS-IMPORT-CONTACTS-SOURCES-BUTTON', "Import")}
            cbClick={sourceSettings.cbImportSourceClick}
            className='importSourceButton'
            buttonType='primaryGreen'
          />
        </ImportListContainer>
        {formattedSyncDate}
      </React.Fragment>
    );
  });

  return (
    <ImportContactsContainer className="NotificationsContainer">
      {ImportSourcesArea}
    </ImportContactsContainer>
  );
};

ImportContacts.propTypes = {
  importSourceArray: PropTypes.array
};

ImportContacts.defaultProps = {
  importSourceArray: []
};

export default ImportContacts;
